<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
div
    ib-row(v-if="hideInfo")
        ib-col(class="s12 m5 l3 xl2")
            ib-dropdown(
                class="currency-drop"
                :data="currencyList",
                v-model="selectedCurrency",
                style="margin-right:0; margin-left: 0;"
                :class="{'flex-flex' : !$media.l}"
            )
    ib-row(v-else, class="border-bottom insety-16")
        ib-col(class="xl2 s12")
            p(:class="{'insety-16': $media.xl, 'insetx-4': $media.l}")
                span(
                    class="end-8 info", 
                    :class="{'start-0': !$media.m, 'start-4': $media.xl}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext") {{ $t('choose_currency') }}
                span {{ $t('currency') }}
        ib-col(
            class="xl10 s12", 
            :class="{'inset-16': !$media.s, 'insety-16': $media.s, 'start-8': $media.l}"
        )
            div(:class="{ 'flex-flex': !$media.l }")
                ib-dropdown(
                    class="currency-drop"
                    :data="currencyList",
                    v-model="selectedCurrency",
                    style="margin-right:0;"
                )
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'CurrencySelector',
        data() {
            return {
            }
        },
        props: {
            hideInfo: Boolean
        },
        methods: {
            ...mapActions(['setSelectedCurrency'])
        },
        computed: {
            currencyList: function() {
                const display = [];
                display[0] = { label: this.$t('select_cur'), value: "" };
                for (let i = 0; i < this.currencies.length; i++) {
                    display[i+1] = {label: this.$t(this.currencies[i].name), value: this.currencies[i].value};
                }

                return display;
            },
            selectedCurrency: {
                get: function() {
                    return this.$store.state.selectedCurrency;
                },
                set: function(newValue) {
                    this.setSelectedCurrency(newValue);
                    this.$emit('update');
                }
            },
            ...mapState(['currencies']),
        }
    }
</script>

<style lang="less" scoped>
    .currency-drop {
        margin-right: 0;
    }
    .extra-pad {
        padding-left: 16px;
    }
    @media (max-width: 600px) {
        .currency-drop {
            margin-left: 0;
        }
    }
</style>